import { render } from "./HeroiconsOutlineHeart.vue?vue&type=template&id=3852c974"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineHeart.vue"]])

export default __exports__